module.exports = __webpack_public_path__ + "static/media/icon-plus.942f77e7.svg";